import './styles/root.css'

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import Context from './utils/context'
import App from './app'

const root = createRoot(document.getElementById('app'))

root.render(
  <StrictMode>
    <Context>
      <App />
    </Context>
  </StrictMode>
)

DEV || navigator.serviceWorker?.register('/sw.js')
